import { ElementRef, OnChanges, Input, EventEmitter, OnInit, Output, Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import 'ion-rangeslider';
// TODO: Delete this component (jQuery) and do in skeletor DS
declare let $: any;

@Component({
  selector: 'lms-range',
  templateUrl: './range.component.html',
  styleUrls: ['./range.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RangeComponent),
      multi: true
    }
  ]
})
export class RangeComponent implements OnInit, OnChanges, ControlValueAccessor {
  @Input() config: any;
  @Input() getValue: number;
  @Output() rangeSelected: EventEmitter<any | any[]> = new EventEmitter<any | any[]>();

  public rangeConfig: any = {
    keyboard: true,
    grid: true
  };

  public el: ElementRef;
  public inputElem: any;
  public slider: any;

  public propagateChange = (_: any) => {};
  public propagateTouched = (_: any) => {};

  constructor(el: ElementRef) {
    this.el = el;
  }

  ngOnInit() {}

  ngOnChanges() {
    this.initSlider();
  }

  writeValue(value: any) {}

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn) {
    this.propagateTouched = fn;
  }

  public initSlider() {
    if (this.slider) {
      this.slider.update(this.getSliderConfig());
    } else {
      const inputElem = this.el.nativeElement.getElementsByTagName('input')[0];
      $(inputElem).ionRangeSlider(this.getSliderConfig());
      this.slider = $(inputElem).data('ionRangeSlider');
      this.config.slider = this.slider;
    }
  }

  public getSliderConfig() {
    this.rangeConfig = Object.assign({}, this.rangeConfig, this.config, {
      onFinish: (event) => this.onFinish(event)
    });
    return this.rangeConfig;
  }

  onFinish(event) {
    if (this.config.onFinish) {
      this.config.onFinish(event);
    }
    this.propagate(event);
  }

  propagate(event) {
    const sufix = this.rangeConfig.prettify ? '_pretty' : '';
    const value = this.rangeConfig.type === 'double' ? [event['from' + sufix], event['to' + sufix]] : event.from_pretty;
    this.rangeSelected.next(value);
    this.propagateChange(value);
  }
}
